import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { CellAdjustmentComponent } from './cell-adjustment.component';
import { TdAdjustmentModule } from "app_quotation/shared/components/table/td-adjustment/td-adjustment.module";
import { TdNumberValueEditableModule } from 'libraries/component/table/td-number-value-editable/td-number-value-editable.module';
import { ReactiveFormsModule } from "@angular/forms";

@NgModule({
    imports: [
        CommonModule,
        TdAdjustmentModule,
        TdNumberValueEditableModule,
        ReactiveFormsModule,
    ],
    exports: [
        CellAdjustmentComponent,
    ],
    declarations: [
        CellAdjustmentComponent
    ],
    providers: [],
})
export class CellAdjustmentModule {
}
